'use strict';

var mcb = mcb || {};

mcb.lazyLoad = mcb.lazyLoad || new function () {

    this.init = function () {

        const webpIsSupported = document.documentElement.classList.contains("webp");

        if (webpIsSupported) {
            let lazyBg = document.querySelectorAll(".lazy[data-bg]");
            lazyBg.forEach(function (element, index) {
                var bg = element.dataset.bg;
                if (bg.indexOf("format") !== -1) {
                    bg = bg.replace(/format=([^&]*)/, "format=webp");
                }
                else {
                    bg = bg + "&format=webp";
                }
                element.setAttribute("data-bg", bg);
            });
        }

        // Instance lazy load
        var lazyLoadInstance = new LazyLoad({
            callback_loaded: (el) => {
                let imgTile = el.closest(".image-tile");
                if (imgTile) {
                    imgTile.classList.add("image-tile--loaded");
                    imgTile.style.removeProperty("background-color");
                }
            }
        });
    };
}();